exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-complete-enter-active[data-v-51767b5d], .list-complete-leave-active[data-v-51767b5d] {\n    -webkit-transition: opacity .5s;\n    transition: opacity .5s;\n}\n.list-completee-enter[data-v-51767b5d], .list-complete-leave-to[data-v-51767b5d] {\n    opacity: 0;\n}\n", ""]);

// exports
